import request from "@/http";
const insertData = (data) => {
  let { mid_table_remark_001,mid_table_remark_002,mid_table_remark_003,mid_table_remark_004,id_public_middle_table,id_public_user_info, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_insert_or_update_middle_table",
      pre_db_para_id_public_middle_table: id_public_middle_table,
      id_public_user_info: id_public_user_info,
      mid_table_remark_001: mid_table_remark_001,
      mid_table_remark_002: mid_table_remark_002,
      mid_table_remark_003: mid_table_remark_003,
      mid_table_remark_004: mid_table_remark_004,
      pre_db_para_middle_table_name: "public_middle_table_30003",
      type_middle_app: 30003,
      type_inner_app: 1001,
      is_online: 0
    },
    loading: {
      enabled: isloading
    }
  })
}
const getInsertData = (data) => {
  let { id_public_user_info,mid_table_remark_004, isloading = false } = data;
  return request.post({
    url: "duzikai_api_mgr_public_middle_table",
    data: {
      invoke_method: "public_load_middle_table_list",
      pre_db_para_begin_idx: 0,
      pre_db_para_length_4_list: 10,
      type_middle_app: 30003,
      type_inner_app: 1001,
      pre_db_para_middle_table_name: "public_middle_table_30003",
      id_public_user_info: id_public_user_info,
      mid_table_remark_004: mid_table_remark_004,
      is_online: 0,
      pre_db_para_order_by_para: ' time_insert desc ',
    },
    loading: {
      enabled: isloading
    }
  })
}
export default {
  insertData,
  getInsertData
}
